import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export default function CustomRequestForm() {
  const [form, setForm] = useState({
    brand_name: "", industry: "", product: "", target_audience: "",
    duration: "30s", goal: "", budget: "", email: "", notes: "",
  });
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target?.value ?? e });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/custom-requests", form);
      toast.success("Request submitted. We'll match you within 24 hours.");
      setForm({ brand_name: "", industry: "", product: "", target_audience: "", duration: "30s", goal: "", budget: "", email: "", notes: "" });
    } catch {
      toast.error("Failed to submit — please try again.");
    } finally { setLoading(false); }
  };

  const cls = "bg-black/40 border-white/10 focus:border-[#FF6B00] text-white placeholder:text-white/30";

  return (
    <form onSubmit={submit} className="cw-card rounded-2xl p-6 lg:p-8 space-y-4">
      <div className="grid sm:grid-cols-2 gap-4">
        <Input required data-testid="custom-brand" placeholder="Brand name" value={form.brand_name} onChange={update("brand_name")} className={cls} />
        <Input required data-testid="custom-industry" placeholder="Industry (e.g. Beauty)" value={form.industry} onChange={update("industry")} className={cls} />
      </div>
      <Input required data-testid="custom-product" placeholder="Product / offer" value={form.product} onChange={update("product")} className={cls} />
      <Input required data-testid="custom-audience" placeholder="Target audience" value={form.target_audience} onChange={update("target_audience")} className={cls} />
      <div className="grid sm:grid-cols-2 gap-4">
        <Select value={form.duration} onValueChange={(v) => setForm({ ...form, duration: v })}>
          <SelectTrigger data-testid="custom-duration" className={cls}><SelectValue placeholder="Duration" /></SelectTrigger>
          <SelectContent className="bg-[#0F0F0F] border-white/10 text-white">
            <SelectItem value="15s">15 seconds</SelectItem>
            <SelectItem value="30s">30 seconds</SelectItem>
            <SelectItem value="45s">45 seconds</SelectItem>
            <SelectItem value="60s">60 seconds</SelectItem>
          </SelectContent>
        </Select>
        <Input required data-testid="custom-budget" placeholder="Budget (₹)" value={form.budget} onChange={update("budget")} className={cls} />
      </div>
      <Input required data-testid="custom-goal" placeholder="Goal (e.g. Lead-gen, awareness)" value={form.goal} onChange={update("goal")} className={cls} />
      <Input type="email" data-testid="custom-email" placeholder="Email (optional)" value={form.email} onChange={update("email")} className={cls} />
      <Textarea data-testid="custom-notes" placeholder="Anything else we should know?" rows={3} value={form.notes} onChange={update("notes")} className={cls} />
      <button type="submit" disabled={loading} className="cw-btn-primary w-full" data-testid="custom-submit">
        {loading ? "Submitting…" : "Request Custom Script"}
      </button>
    </form>
  );
}
